import { render, staticRenderFns } from "./distwithdraw.vue?vue&type=template&id=3a05972e&"
import script from "./distwithdraw.vue?vue&type=script&lang=js&"
export * from "./distwithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports